import React from 'react'

import { I18nContext } from './context'
import type { I18n } from './types'

export function useI18n(): I18n {
    return React.useContext(I18nContext)
}
